import { render, staticRenderFns, recyclableRender, components } from "./u-keyboard.vue?vue&type=template&id=59248347&scoped=true&"
var renderjs
import script from "./u-keyboard.vue?vue&type=script&lang=js&"
export * from "./u-keyboard.vue?vue&type=script&lang=js&"
import style0 from "./u-keyboard.vue?vue&type=style&index=0&id=59248347&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59248347",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "node_modules/uview-ui/components/u-keyboard/u-keyboard.vue"
export default component.exports